module.exports = __webpack_public_path__ + "static/media/souhoola.1878ccca.png";